// État du formulateur cosmétique : helpers PURS (sans React).
// Isolés ici pour être testables sous vitest et garder Formulateur/useFormulateur
// légers. Le formulateur s'appuie sur le socle logique C1 (shared/cosmetique).

import { FAMILLES, type FormuleCosmetique, type Famille } from '@shared/cosmetique'

/** Convertit une saisie texte en nombre (virgule acceptée), ou 0 si invalide/vide. */
export function enNombre(v: string): number {
  if (v.trim() === '') return 0
  const n = Number(v.replace(',', '.'))
  return Number.isFinite(n) ? n : 0
}

/** Une formule cosmétique vierge (poids par défaut 100 g, toutes phases vides). */
export function formuleVide(): FormuleCosmetique {
  return {
    type_produit: '',
    poids_total: 100,
    phase_aqueuse: [],
    phase_huileuse: [],
    emulsifiant: [],
    actifs: [],
    conservateurs: [],
    parfum: [],
    destine_enfants: false,
    a_rincer: false,
  }
}

/**
 * L'étape « Infos » est complète quand un type de produit est choisi et que le
 * poids total est strictement positif (base de la conversion % -> g).
 */
export function infosCompletes(formule: FormuleCosmetique): boolean {
  return formule.type_produit.trim() !== '' && formule.poids_total > 0
}

/** Une famille avec ses types, pour bâtir un <select> groupé (optgroup). */
export interface GroupeTypes {
  famille: Famille
  types: string[]
}

/** Les familles et leurs types, dans l'ordre de déclaration (pour le select). */
export function famillesPourSelect(): GroupeTypes[] {
  return Object.values(FAMILLES).map((famille) => ({ famille, types: famille.types }))
}
